/** @description Получение ширины элемента в браузере
 * @param {HTMLElement} block элемент
 * @return {number}
 */
export function getBlockWidth(block) {
  if (!block) {
    return 0;
  }
  return block.clientWidth;
}